import EventForm from "./EventForm"

export const EventCreator = () => {
    return <EventForm />;
}
